import { createSlice } from "@reduxjs/toolkit";

const childContactsSlice = createSlice({
    name: "childContactsSetup",
    initialState: {
      childContactsData: null,
    },
    reducers: {
      setchildContactsData: (state, action) => {
        state.childContactsData = action?.payload
      },
    }
  });


// this is for dispatch
export const { childContactsData } = childContactsSlice.actions;

// this is for configureStore
export default childContactsSlice.reducer;